var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailgold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_2590_44739)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9643 8.10693H7.03571C6.7394 8.10693 6.5 8.34633 6.5 8.64265V19.3569C6.5 19.6532 6.7394 19.8926 7.03571 19.8926H20.9643C21.2606 19.8926 21.5 19.6532 21.5 19.3569V8.64265C21.5 8.34633 21.2606 8.10693 20.9643 8.10693ZM19.6116 9.93004L14.3298 14.04C14.1992 14.1421 14.0167 14.1421 13.8862 14.04L8.60268 9.93004C8.58276 9.91467 8.56815 9.89345 8.5609 9.86936C8.55365 9.84527 8.55412 9.81951 8.56224 9.7957C8.57036 9.77189 8.58573 9.75122 8.60619 9.73658C8.62665 9.72194 8.65118 9.71407 8.67634 9.71408H19.5379C19.5631 9.71407 19.5876 9.72194 19.6081 9.73658C19.6286 9.75122 19.6439 9.77189 19.652 9.7957C19.6602 9.81951 19.6606 9.84527 19.6534 9.86936C19.6461 9.89345 19.6315 9.91467 19.6116 9.93004Z",
    fill: "#2B2B2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_44739",
    x1: 14,
    y1: -5.04,
    x2: 14,
    y2: 32.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailgold);
export default __webpack_public_path__ + "static/media/mailgold.3388b18fe5f405ade91144105b158046.svg";
export { ForwardRef as ReactComponent };